document.addEventListener("DOMContentLoaded", () => {
    const wrapperClass = "custom_artwork_popup";

    if (!document.querySelector(`.${wrapperClass}`)) {
        const wrapper = document.createElement("div");
        wrapper.className = wrapperClass;
        document.body.appendChild(wrapper);

        const observer = new MutationObserver(() => {
            const el = document.querySelector("#tee-artwork-form");

            if (el && !wrapper.contains(el)) {
                wrapper.appendChild(el);
                console.log("Artwork found and wrapped");

                // Create the close button inside artwork form
                const closeButton = document.createElement("span");
                closeButton.className = "close_artwork_popup";
                el.appendChild(closeButton);

                closeButton.addEventListener("click", () => {
                    if (wrapper.classList.contains("active_popup")) {
                        wrapper.classList.remove("active_popup");
                        console.log("active_popup removed");
                    }
                });
closeButton.addEventListener("click", () => {
    if (wrapper.classList.contains("active_popup")) {
        wrapper.classList.remove("active_popup");
        console.log("active_popup removed");
    }
});

// ⭐ ADD CONTINUE BUTTON TO TEEINBLUE FORM ⭐
setTimeout(() => {
    const tibFormInputs = document.getElementById('tee-artwork-form');
    const existingButton = tibFormInputs?.querySelector('.tib-custom-continue-wrapper');
    
    if (tibFormInputs && !existingButton) {
        console.log('✅ Adding Continue button to TIB form');
        
       const buttonHTML = `
    <div class="tib-custom-continue-wrapper" style="
        position: sticky;
        bottom: 0;
        background: white;
        padding: 16px;
        margin-top: 20px;
        border-top: 3px solid #D7A13B;
        box-shadow: 0 -4px 12px rgba(0,0,0,0.12);
        z-index: 999999;
    ">
        <button type="button" class="tib-done-btn" style="
            background: linear-gradient(135deg, #D7A13B 0%, #F8CC63 100%);
            color: #fff;
            padding: 14px 20px;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-weight: 700;
            font-size: 15px;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            box-shadow: 0 3px 10px rgba(215, 161, 59, 0.4);
            transition: all 0.2s ease;
        ">
            ✓ DONE - CONTINUE SHOPPING
        </button>
        <p style="
            text-align: center;
            margin: 10px 0 0 0;
            font-size: 12px;
            color: #666;
            font-weight: 500;
            line-height: 1.3;
        ">
            Your customization has been saved automatically!
        </p>
    </div>
`;
        
        tibFormInputs.insertAdjacentHTML('beforeend', buttonHTML);
        
        const doneBtn = tibFormInputs.querySelector('.tib-done-btn');
        
        // Hover effects
        doneBtn.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.02)';
            this.style.opacity = '0.95';
        });
        
        doneBtn.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
            this.style.opacity = '1';
        });
        
        // Click to close popup
doneBtn.addEventListener('click', function() {
    console.log('🔘 Done button clicked - adding to cart');

    // Store original text
    const originalText = this.textContent;

    // Disable button to prevent double-clicks
    this.disabled = true;
    this.style.opacity = '0.6';
    this.textContent = 'ADDING TO CART...';

    // Find the Add to Cart button
    const addToCartBtn = document.querySelector('.product-form__submit') ||
                         document.querySelector('#product_custom_atc') ||
                         document.querySelector('.add_to_cart');

    if (addToCartBtn) {
        console.log('✅ Clicking Add to Cart button');
        addToCartBtn.click();

        // Watch for SlideCart to open, then close popup
        const checkInterval = setInterval(() => {
            const slideCart = document.querySelector("#slidecarthq .slidecarthq");
            const isOpen = slideCart && slideCart.classList.contains("open");

            if (isOpen) {
                console.log('✅ SlideCart opened - closing popup');
                wrapper.classList.remove("active_popup", "active-upload");

                // Reset button text and state
                doneBtn.textContent = originalText;
                doneBtn.disabled = false;
                doneBtn.style.opacity = '1';

                clearInterval(checkInterval);
            }
        }, 100);

        // Safety timeout - close after 3 seconds even if SlideCart doesn't open
        setTimeout(() => {
            clearInterval(checkInterval);
            wrapper.classList.remove("active_popup", "active-upload");

            // Reset button text and state
            doneBtn.textContent = originalText;
            doneBtn.disabled = false;
            doneBtn.style.opacity = '1';

            console.log('⏱️ Timeout - closing popup');
        }, 3000);

    } else {
        console.warn('⚠️ Add to Cart button not found');
        this.disabled = false;
        this.style.opacity = '1';
        this.textContent = originalText;
    }
});

        
        console.log('✅ Continue button added successfully!');
    }
}, 500);
// ⭐ END CONTINUE BUTTON CODE ⭐

// Move product buttons into popup
                // Move product buttons into popup
                // const productButtons = document.querySelector("product-form.product-form");
                // if (productButtons && !wrapper.contains(productButtons)) {
                //     wrapper.appendChild(productButtons);
                //     console.log("Moved product-form.product-form into popup");
                // }

                // ⭐ ADD-TO-CART BUTTON LOGIC
                setupAddToCartCloseLogic(wrapper);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Open popup when variant label clicked
    document.body.addEventListener("click", (e) => {
        const label = e.target.closest(".product-form__input--pill input[type=radio] + label");
        if (label) {
            const wrapper = document.querySelector(".custom_artwork_popup");
            if (wrapper && !wrapper.classList.contains("active_popup")) {
                wrapper.classList.add("active_popup");
            }
        }
    });
});


// ⭐ Function to handle Add-to-Cart → Wait for SlideCart → Close popup
function setupAddToCartCloseLogic(wrapper) {
    const addToCartBtn = document.querySelector(".product-form__buttons .product-form__submit");

    if (!addToCartBtn) {
        console.warn("Add to cart button not found");
        return;
    }

    addToCartBtn.addEventListener("click", () => {
        // Check every 100ms until SlideCart is open
        const checkInterval = setInterval(() => {
            const slideCart = document.querySelector("#slidecarthq .slidecarthq");
            const isOpen = slideCart && slideCart.classList.contains("open");

            if (isOpen) {
                wrapper.classList.remove("active_popup");
                console.log("SlideCart opened → popup closed");

                clearInterval(checkInterval);
            }
        }, 100);

        // Safety timeout (stop after 5 seconds)
        setTimeout(() => clearInterval(checkInterval), 5000);
    });
}


// Default variant selection
document.addEventListener("DOMContentLoaded", () => {
    const defaultVariant = document.querySelector(
        'input[type="radio"][value="The Ultimate Pet Lover"]'
    );
    if (defaultVariant && !defaultVariant.checked) {
        defaultVariant.checked = true;
        defaultVariant.dispatchEvent(new Event("change", { bubbles: true }));
    }
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".bfs_ups_bar");

  if (!section) return;

  const slider = section.querySelector("ul.multicolumn-list.slider");

  if (!slider) return;

  // Mobile only
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  if (!isMobile) return;

  let slideWidth =
    slider.querySelector(".multicolumn-list__item")?.clientWidth || 200;

  let currentScroll = 0;

  const autoScroll = () => {
    if (!document.body.contains(slider)) return;

    currentScroll += slideWidth;

    // Loop when reaching end
    if (currentScroll >= slider.scrollWidth - slider.clientWidth) {
      currentScroll = 0;
    }

    slider.scrollTo({
      left: currentScroll,
      behavior: "smooth",
    });
  };

  // Auto-scroll every 3 seconds
  setInterval(autoScroll, 3000);
});


document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('input[name="Limited Time Deal"]');
  const uploadDiv = document.querySelector(".upload-custom_tib_field");
  const popup = document.querySelector(".custom_artwork_popup");

  // On page load: set data-tib-upload based on checked radio
  function initializeDataAttribute() {
    radios.forEach((radio, index) => {
      if (radio.checked) {
        uploadDiv.setAttribute("data-tib-upload", index + 1);
      }
    });
  }

  initializeDataAttribute();

  // On radio click: update data-tib-upload
  radios.forEach((radio, index) => {
    radio.addEventListener("change", function () {
      uploadDiv.setAttribute("data-tib-upload", index + 1);
    });
  });

  // On click of the uploadDiv, add active-upload class
  uploadDiv.addEventListener("click", function () {
    if (popup) {
      popup.classList.add("active-upload");
    }
  });

  // Close button removes active-upload using event delegation
  document.addEventListener("click", function (e) {
    if (e.target.closest(".close_artwork_popup")) {
      if (popup) {
        popup.classList.remove("active-upload");
      }
    }
  });
});

/******** Moving Section Location ********/

document.addEventListener("DOMContentLoaded", function() {
  const flexibleTabsParent = document.querySelector('[data-flexible-tabs]');
  const flexibleTabsSettings = document.querySelector('[data-flexible-tabs] [data-flexible-tabs-settings]');
  const productMediaGallery = document.querySelector('.product__media-wrapper media-gallery');

  if (!flexibleTabsParent || !flexibleTabsSettings || !productMediaGallery) return;

  const placeholder = document.createComment('flexible-tabs-settings-original-position');
  flexibleTabsSettings.before(placeholder);

  function moveTabs() {
    if (window.innerWidth >= 750) {
      productMediaGallery.after(flexibleTabsSettings);
    } else {
      placeholder.after(flexibleTabsSettings);
    }
  }

  moveTabs();

  window.addEventListener('resize', moveTabs);
});